import React from "react";
import "./home.css";
import Me from "../../assets/avatar.svg";
import HeaderSocials from "./HeaderSocials";
import ScrollDown from "./ScrollDown";
import Shapes from "./Shapes";

function Home(props) {
  return (
    <section className="home container" id="home">
      <div className="intro">
        <img src={Me} alt="" className="home__img" />
        <h1 className="home__name">Anoohya Nalla</h1>
        <span className="home__education">
          Front-End Developer | Software Developer | Full-stack Developer
        </span>
        <HeaderSocials />
        <a href="#contact" className="btn">
          Hire Me
        </a>
        <ScrollDown />
      </div>
      <Shapes />
    </section>
  );
}

export default Home;
